module.exports = __webpack_public_path__ + "static/media/third_single_layer.9086bcc6.png";